import { TherapeuticGroupType } from '@dreryk/egabinet-group-session-frontend-api';

import { createInterpolatedTranslationKey, TranslateFunction } from '@dreryk/react-common';
import {
   FilterPanel,
   FilterPanelControllerCodecConfigArray,
   FilterPanelControllerDeselectorsPropsMapper,
} from '@dreryk/react-components';

import { translationKeys } from '../../../translations';
import { GroupSessionsFilterPanelSearchParam } from '../../GroupSessionsFilterPanel.types';

export const GROUP_TYPES: TherapeuticGroupType[] = ['CLOSED', 'SEMI_CLOSED', 'OPEN'];

const GROUP_TYPE_TO_SEARCH_PARAM: Record<TherapeuticGroupType, number> = {
   CLOSED: 0,
   SEMI_CLOSED: 1,
   OPEN: 2,
};

export const createGroupTypeTriggerLabelExtractor = (
   translate: TranslateFunction
): ((chosenGroupTypes: TherapeuticGroupType[]) => string) => {
   return (chosenGroupTypes) => {
      if (chosenGroupTypes.length === 1) {
         return translate(translationKeys.groupSessionsTypeMap[chosenGroupTypes.at(0)!]);
      }
      return translate(
         createInterpolatedTranslationKey(translationKeys.chosenOptions, {
            count: chosenGroupTypes.length,
            totalCount: GROUP_TYPES.length,
         })
      );
   };
};

export const groupTypesCodec: FilterPanelControllerCodecConfigArray<TherapeuticGroupType> = {
   type: 'array',
   items: GROUP_TYPES,
   keyGenerator: (groupType) => GROUP_TYPE_TO_SEARCH_PARAM[groupType],
};

export const groupTypesDeselectorsPropsMapper: FilterPanelControllerDeselectorsPropsMapper<
   TherapeuticGroupType[],
   GroupSessionsFilterPanelSearchParam.GROUP_TYPE
> = (currentGroupTypes) => {
   return currentGroupTypes.map((groupType) => ({
      targetValue: currentGroupTypes.filter((currentGroupType) => currentGroupType !== groupType),
      label: translationKeys.groupSessionsTypeMap[groupType],
      testId: `groupType-${groupType}`,
   }));
};

export const groupTypeDeserializer = (currentParamValue: string | null): TherapeuticGroupType[] => {
   return FilterPanel.paramToArray(
      currentParamValue,
      'number',
      (item) => GROUP_TYPES.find((groupType) => GROUP_TYPE_TO_SEARCH_PARAM[groupType] === item)!
   );
};
